module.exports = __webpack_public_path__ + "img/Feature.02f53e3b.png";